import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const incidentValidation = yup.object().shape({
    status: yup.string().required(ERRORS.required),
    priority: yup.string().required(ERRORS.required),
    type: yup.string().required(ERRORS.required),
    notes: yup.mixed().required(ERRORS.required),
});
